/**
 * Barra de ações do editor de Persona (PR3 · gate `persona-author`). Aparece
 * quando há alterações não salvas; oferece Descartar e Salvar. Reflete o estado
 * salvando e uma mensagem de erro genérica (o conflito 409 tem banner próprio na
 * view). Espelha `PlaybookActionBar` (Brief 4 · Tela 1).
 */

import { Save, Undo2 } from 'lucide-react';

export function PersonaActionBar({
  isDirty,
  isSaving,
  errorMessage,
  onSave,
  onDiscard,
}: {
  isDirty: boolean;
  isSaving: boolean;
  errorMessage: string | null;
  onSave: () => void;
  onDiscard: () => void;
}): JSX.Element | null {
  if (!isDirty && !isSaving) return null;

  return (
    <div className="pe-actionbar" role="region" aria-label="Ações de edição">
      <span className="pe-actionbar__status">
        {isSaving ? 'Salvando…' : 'Alterações não salvas'}
      </span>
      {errorMessage !== null && <span className="pe-actionbar__error">{errorMessage}</span>}
      <div className="pe-actionbar__buttons">
        <button type="button" className="pe-btn" disabled={isSaving} onClick={onDiscard}>
          <Undo2 size={14} /> Descartar
        </button>
        <button
          type="button"
          className="pe-btn pe-btn--primary"
          disabled={isSaving}
          onClick={onSave}
        >
          <Save size={14} /> Salvar
        </button>
      </div>
    </div>
  );
}
